export default __webpack_public_path__ + "static/media/ducati.690d5688.webp";